import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgMatrixCompose } from '../../fg-math.js';

const matrixComposeDef = {
  type: FgBlockType.MatrixCompose,
  build: () => ({
    dataIn: [sockIn("position", FgType.Vector3), sockIn("rotationQuaternion", FgType.Quaternion), sockIn("scaling", FgType.Vector3)],
    dataOut: [sockOut("value", FgType.Matrix)]
  }),
  updateOutputs(block, ctx, env) {
    const pos = getDataValue(ctx, env, block, "position");
    const quat = getDataValue(ctx, env, block, "rotationQuaternion");
    const scale = getDataValue(ctx, env, block, "scaling");
    setDataValue(ctx, block, "value", fgMatrixCompose(pos, quat, scale));
  }
};

export { matrixComposeDef };
//# sourceMappingURL=matrix-compose.js.map
